(ns app.front.view.admin.commands.unlock-tasks
  (:require [app.domain.util :as du]
            [app.front.ui :as ui]
            [app.front.ui.radio :as ui-radio]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-db ::select-attr
  (rf/path [::state])
  (fn [state [_ value]]
    (-> state
        (assoc ::attr value)
        (dissoc :tasks :selected))))

(rf/reg-event-db ::set
  (rf/path [::state])
  (fn [state [_ attr value]]
    (-> state
        (assoc attr value)
        (dissoc :tasks :selected))))

(rf/reg-sub ::state
  :-> ::state)

(rf/reg-sub ::selected-attr
  :<- [::state]
  (fn [state _] (::attr state :email)))

(rf/reg-sub ::value
  :<- [::state]
  :<- [::selected-attr]
  (fn [[state attr] _] (get state attr)))

(rf/reg-event-fx ::fetch-tasks
  (fn [{:keys [db]} [_ attr val]]
    {:comm/command {:command    :admin/get-tasks-for-user-or-group
                    :data       {attr val}
                    :on-success [::fetch-tasks.success]}
     :db           (update db ::state dissoc :tasks)}))

(rf/reg-event-fx ::fetch-tasks.success
  (fn [{:keys [db]} [_ status tasks]]
    (when (= 200 status)
      {:db (-> db
               (assoc-in [::state :tasks] tasks))})))

(rf/reg-event-fx ::apply
  (fn [_ [_ task-ids]]
    {:comm/command {:command    :admin/unlock-tasks
                    :data       (util/mmap task-ids)
                    :on-success [::apply.success]}}))

(rf/reg-event-fx ::apply.success
  (fn [{:keys [db]} [_ status]]
    (when (= 200 status)
      {:db (-> db
               (update ::state dissoc :tasks :selected))})))

(rf/reg-sub ::fetched?
  :<- [::state]
  (fn [state _]
    (-> state :tasks some?)))

(rf/reg-sub ::tasks
  :<- [::state]
  (fn [state _]
    (->> state
         :tasks
         (sort-by :workspace-id)
         seq)))

(rf/reg-sub ::selected
  :<- [::state]
  :-> :selected)

(rf/reg-sub ::selected?
  :<- [::selected]
  (fn [selected [_ task-id]]
    (-> selected
        (contains? task-id))))

(rf/reg-event-db ::set-selected
  (rf/path [::state])
  (fn [state [_ task-id]]
    (-> state
        (update :selected #((if (contains? % task-id) disj conj)
                            (or % #{})
                            task-id)))))

(defn selector [{task-id :db/id
                 :as     task}]
  (let [already-removable? (or (:task/removable? task)
                               (du/in-state? :task.state/removed task)
                               (du/in-state? :task.state/ready task))]
    (cc/checkbox
      {:label-text ""
       :id         (str "select-" task-id)
       :disabled   already-removable?
       :on-change  #(>evt [::set-selected task-id])
       :checked    (or already-removable?
                       (<sub [::selected? task-id]))})))

(defn view [match]
  [acommon/admin-page
   (util/mmap {:title "Unlock tasks"} match)
   [:section
    [:div
     "This tool can be used to find the tasks assigned to a specific user or group (or child group)
     and enable the 'Delete task' button on selected tasks, regardless of if it is normally not allowed."]
    (let [selected-attr (<sub [::selected-attr])
          value         (<sub [::value])]
      [:<>
       [ui-radio/radio {:values    [:email :group-id :task-id]
                        :value     selected-attr
                        :val->str  name
                        :name      "attr-select"
                        :on-change #(>evt [::select-attr %])}]
       [ui/text-input
        {:value       value
         :class       "mt-2"
         :on-change   #(rf/dispatch-sync [::set selected-attr (cond-> (futil/tval %)
                                                                (= :task-id selected-attr)
                                                                futil/parse-int)])
         :label-text  (case selected-attr
                        :email    "User email address"
                        :group-id "Group id"
                        :task-id  "Task id")
         :placeholder (case selected-attr
                        :email    "andrew.applicant@example.com"
                        :group-id "CA-3537039-B"
                        :task-id  "17592186060000")}]
       (cc/button {:on-click   #(>evt [::fetch-tasks selected-attr value])
                   :disabled   (<sub [::fetched?])
                   :class-name "mt-2"}
                  "Fetch tasks")])]
   (when-let [tasks (<sub [::tasks])]
     (let [tr       (<sub [:tr])
           selected (<sub [::selected])]
       [:section
        [ui-table/modern-responsive-table
         {:tr    tr
          :cols  [["Allow remove?" (fn [task] [selector task])]
                  ["Workspace ID" :workspace-id]
                  [:task/type #(tr [(:task/type %)])]
                  [:domain/state #(tr [(:domain/state %)])]]
          :items tasks}]
        (cc/button {:on-click   #(>evt [::apply (vec selected)])
                    :disabled   (empty? selected)
                    :class-name "mt-2"}
                   "Set tasks removable")]))])

(def route
  {:name :view/admin.commands.unlock-tasks
   :view view})
